<template>
  <header class="header">
    <div class="brand">
      <img class="brand-mark" src="../assets/cross.png" alt="" />
      <span class="brand-text">Ärztliche Bereitschaftsdienste</span>
    </div>
  </header>
</template>

<script setup>
</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 72px;
  padding: 14px 24px;
  background-color: #ffffff;
  border-bottom: 2px solid #c9c9c9;
  box-sizing: border-box;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.brand-mark {
  width: 30px;
  height: 30px;
  object-fit: contain;
  flex-shrink: 0;
}

.brand-text {
  font-family: "Open Sans Condensed", "Opensans-Regular", sans-serif;
  color: #425052;
  font-size: 2.2rem;
  line-height: 1.2;
  font-weight: 700;
  text-align: center;
}

@media (max-width: 1023px) {
  .header {
    min-height: 48px;
    padding: 10px 18px;
  }

  .brand {
    gap: 10px;
  }

  .brand-mark {
    width: 20px;
    height: 20px;
  }

  .brand-text {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .header {
    min-height: 42px;
    padding: 8px 12px;
  }

  .brand {
    gap: 8px;
  }

  .brand-mark {
    width: 16px;
    height: 16px;
  }

  .brand-text {
    font-size: 0.88rem;
  }
}
</style>
